import { render, staticRenderFns } from "./regiao.vue?vue&type=template&id=3bfdf4c2&"
import script from "./regiao.vue?vue&type=script&lang=js&"
export * from "./regiao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports